export default "__VITE_ASSET__BEdZQCpo__"